import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/packagesSalesSaga";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import GoogleChart from "../../../../components/charts/googleChart/googleChart";

const TableOrLineChart = () => {
  const dispatch = useDispatch();
  const { data_table: { rows = [], cols = [] } = {}, options } = useSelector(
    (state) => state.packagesSales.chartData
  );
  const table_view = useSelector((state) => state.packagesSales.selectedFilters.table_view);
  const status = useSelector((state) => state.packagesSales.chartInfo.status);

  if (status === "idle") return null;
  if (status === "loading") return <LoadingAnimation text="Updating data..." />;

  const switchView = (data) => {
    dispatch(actionCreators.updateTableView(data));
  };

  return (
    <GoogleChart
      chartName="packages_sales_chart"
      width="1350px"
      height="400"
      isTableView={table_view}
      rows={rows}
      columns={cols}
      options={options}
      enableEventListeners
      chartType={table_view ? "Table" : "LineChart"}
      showAdditionTooltip={false}
      showXLSX={table_view}
      switchView={switchView}
    />
  );
};

export default TableOrLineChart;
